import events from 'events.js';

(async function() {
    await events.ready();
    const dataset = document.body.dataset;
    const scrollToSearch = dataset.scrollToSearch;

    if (scrollToSearch) {
        const searchBox = document.querySelector('input.search-lg-input');
        events.listen(searchBox, 'focus', function() {
            searchBox.scrollIntoView();
        });
        searchBox.focus();
        searchBox.scrollIntoView();
    }
})();
